import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';

const StickyButton = styled.button.attrs({
  className: 'd-flex p-2 btn-lg d-print-none',
})`
  background: ${colors.linkBlue};
  color: #fff;
  border-radius: 4px 0 0 4px;
  border: none;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);

  &:hover {
    background: ${colors.lightLinkBlue};
  }
`;
const StyledBadgeSpan = styled.span`
  background: inherit;
  padding: 0 0.4rem;
  border-radius: 100%;
  position: absolute;
  left: -10px;
  top: -2px;
  font-size: 65%;
  font-weight: normal;
  min-width: 15px;
`;
type StyledBadgeSpanProps = {
  tooltip: string;
  onClick: () => void;
  badgeContent?: number;
  icon: string;
};
export const SidebarIconButton = ({
  tooltip,
  onClick,
  badgeContent,
  icon,
}: StyledBadgeSpanProps) => {
  return (
    <LazyTooltip tooltip={tooltip} placement="left">
      <StickyButton onClick={onClick}>
        <StyledBadgeSpan>{badgeContent}</StyledBadgeSpan>
        <i className={`fas fa-fw ${icon}`} />
      </StickyButton>
    </LazyTooltip>
  );
};
export const SidebarTopIconButton = ({
  tooltip,
  onClick,
  icon,
}: StyledBadgeSpanProps) => {
  return (
    <LazyTooltip tooltip={tooltip} placement="left">
      <button className="btn btn-sm" onClick={onClick}>
        <i className={`fas fa-fw ${icon}`} />
      </button>
    </LazyTooltip>
  );
};
export const ToggleButtonWrapper = styled.div<{buttonDelta: number}>`
  margin-top: ${({buttonDelta}) => buttonDelta}px;
  top: 50%;
  position: fixed;
  right: 0;
  z-index: 1000;
`;
